import { cloneDeep, isEqual } from 'lodash'

import { DateFields } from '@sigma-frontend-libs/commons'

import { createdAtFilter, defaultInputValue, getLocaleDateString, icons, timeParams, timeToArrayStringsWithLeadZero } from '@/utils'

import render from './render'

export default {
  name: 'DateTimeFilter',

  mixins: [ createdAtFilter ],

  props: {
    title: {
      type: String,
      default: DateFields.createdAt
    },
    label: {
      type: String,
      default: DateFields.createdAt
    },

    min: [ Number, String, Date ],
    max: [ Number, String, Date ],

    disabled: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: false
    },

    preset: {
      type: String,
      default: undefined
    },
    presets: {
      type: Boolean,
      default: false
    },

    showDates: {
      type: Boolean,
      default: false
    },

    asIs: {
      type: Boolean,
      default: false
    },

    /**
     * Режим выбора только дат без времени.
     * При `true` скрывает поля времени и время в тексте активатора.
     *
     * @type {boolean}
     * @default false
     */
    onlyDate: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      date: [],

      initPreset: cloneDeep(this.preset),

      inputChangeInProgress: false,
      presetChangeInProgress: false
    }
  },

  computed: {
    activatorContent() {
      if (this.preset && !this.showDates) {
        return this.getTranslate(`filter.date.presets.${this.preset}`)
      } else {
        const { date, time } = cloneDeep(this.proxy)
        const result = []
        const dates = date.sort().map(item => {
          return getLocaleDateString(item, this.locale)
        })
        const times = []

        if (dates.length) {
          for (const key in time) {
            const value = time[key]
            if (value) {
              const [ hours, minutes ] = timeToArrayStringsWithLeadZero(value)
              times.push(`${hours}:${minutes}`)
            } else {
              times.push('---')
            }
          }

          result.push(dates.join(' - '))
          if (!this.onlyDate) {
            result.push(times.join(' - '))
          }
        } else {
          result.push(this.getTranslate(`filter.date.titles.range.${this.title}`))
        }

        return result.join(' | ')
      }
    },

    activatorButton() {
      if (this.clearable) {
        return {
          icon: icons.clear,
          disabled: !this.proxyIsChanged,
          callback: () => {
            this.proxy = cloneDeep(defaultInputValue)
            this.$emit('preset', this.initPreset)
          }
        }
      }
    }
  },

  watch: {
    proxy: {
      handler() {
        const dateChanged = !isEqual(this.date, this.proxy.date)
        if (dateChanged) {
          this.date = cloneDeep(this.proxy.date)

          if (this.inputChangeInProgress) {
            this.inputChangeInProgress = false
          } else if (!this.presetChangeInProgress) {
            this.$emit('preset', this.initPreset)
          }
        }

        if (this.presetChangeInProgress) {
          this.presetChangeInProgress = false
        }
      },
      deep: true
    },

    date: {
      handler() {
        if (!isEqual(this.date, this.proxy.date)) {
          this.proxy.date = cloneDeep(this.date)
        }
      },
      deep: true
    }
  },

  mounted() {
    this.date = cloneDeep(this.proxy.date)
  },

  methods: {
    _presetInputHandler(event) {
      if (event) {
        this.presetChangeInProgress = true
        this.proxy = {
          date: [],
          time: timeParams
        }
      }

      this.$emit('preset', event)
    },

    _inputHandler(event) {
      if (event) {
        this.inputChangeInProgress = true
        this.$emit('preset', undefined)
        this.date = event
      }
    },

    _pickHandler(event) {
      if (event) {
        this.$emit('pick', event)
        this.inputChangeInProgress = true
        this.$nextTick(() => {
          const dates = cloneDeep(this.date)
          if (dates.length === 0) {
            dates.push(event)
          }
          if (dates.length === 1) {
            dates.push(event)
          }
          if (dates.length === 2) {
            const [ gt, lt ] = dates.sort()
            if (gt && lt && gt <= lt) {
              this.proxy.date = cloneDeep(dates)
              this.proxy.time = cloneDeep(timeParams)
            }
          }
        })
      }
    }
  },

  render
}
